export function isVideoDeviceOffline(patient) {
  return patient.video_device && patient.video_device.status !== 'online'
}
export function offlineDeviceTooltip(patient) {
  return {
    content: 'Video device is offline',
    disabled: !isVideoDeviceOffline(patient),
    placement: 'bottom'
  }
}